<template>
    <div class="d-flex justify-content-center my-2">
        <b-card title=""
            bg-variant="light"
            border-variant="secondary"
            style="max-width: 400px; width: 100%;"
        >
        <!-- Logo Cabecera -->
        <div class="text-center my-2">
            <b-avatar size="4em" variant="secondary" icon="person-fill"></b-avatar>
            </div>

        <!-- usuario -->
        <div v-if="this.logueado" class="mt-3">
            <b-form-group label="ID">
                <b-form-input :value="usuario.id || ''" readonly></b-form-input>
            </b-form-group>
            <b-form-group label="Usuario">
                <b-form-input :value="usuario.name || ''" readonly></b-form-input>
            </b-form-group>
            <b-form-group label="Departamento">
                <b-form-input :value="usuario.dep || ''" readonly></b-form-input>
            </b-form-group>
        </div>
        <div v-else >
            <!-- <b-form @submit.prevent="login"> -->
            <b-form>
                <b-form-group class="pt-2"
                    label="Usuario" label-for="user"
                    v-bind="attr_user">
                    <b-input-group class="my-2">
                    <b-input-group-prepend is-text>
                        <b-icon-person-fill/>
                    </b-input-group-prepend>
                    <b-form-input type="text" id="user" ref="user"
                        v-model="user.user" trim
                        v-bind="attr_user">
                    </b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group
                label="Contraseña / Password" label-for="pass">
                <b-input-group class="my-2">
                    <b-input-group-prepend is-text>
                        <b-icon-check/>
                    </b-input-group-prepend>
                    <b-form-input type="password" id="pass" ref="pass"
                        v-model="user.pass"
                        v-bind="attr_pass">
                    </b-form-input>
                    </b-input-group>
                </b-form-group>
                <!-- Botones -->
                <b-button block pill variant="secondary" type="submit"
                    v-b-tooltip.hover title="Conectar"
                    @click.prevent="check">
                    {{ btn_login }}
                </b-button>
            </b-form>
        </div>
    </b-card>
  </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      user: { user:'', pass:'', error: '', logU: false, logP: false, sid: '' },
      error: { error: false, msg: '', title:'' },

    };
  },
   created() {
    if (this.logueado) {
      if (this.$route.name=='login')
        this.$router.push('/');
      else
        this.$bvModal.hide("modal_login");

    }
  },
  computed: {
    ...mapState(['auth','errores']),

    logueado() {
      return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

    // atributos usuario / acceso
    attr_user() {
      //if (this.user.logU) return {state: true, disabled: false, "valid-feedback": "USUARIO REGISTRADO" };
      //if (this.user.error) return {state: false, disabled: false, "invalid-feedback": this.user.error };
      return { disabled: false};
    },
    attr_pass() {
      return { disabled: false};
    },
    // texto boton
    btn_login() {
      return "CONECTARSE"; //(!this.user.logU ? "CONTINUAR" : "CONECTARSE");
    }
  },
  methods: {
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec']),


    // check -> login (async) -> login_back

    check() {
        let u=this.user.user;
        let p=this.user.pass;
        let t=this.auth.token;

        if (u==='') { this.user.error="Debes Introducir un Usuario"; return; }
        if (p==='') { this.user.error="Debes Introducir una Contraseña"; return; }

        let args={user: u, token: t, pass:p};
        this.login(args);
    },

    async login(args) {
        //this.loading();
        let r=await this.exec({api:'login', arg:args});
        this.login_back(r);
    },

    login_back(r) {
      this.user.error="";
      //////////////////////////////////////////////si error
        if (r.error) {
            this.user.error="Contraseña / Password Incorrecta";
            this.modal({tit:"Login / Acceso", msg: this.user.error});
            this.$refs.pass.focus();
            return;
        }

        this.$store.commit('login_back',r);
        this.$router.push('/expedientes');
    },

    olvidar() {
      alert('Olvidar Contraseña');
      //user.logU=!user.logU

    },

    ttip(txt) {
      return {
        title: txt,
        placement: "topright",
        html: true,
        variant: "secondary",
        customClass: "tooltip1",

      }
    },

  }
}

</script>
